import { useTranslation } from "react-i18next";
import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";

function ArticleReadMore({ navigatePath, className = "absolute bottom-5 left-5 mt-2 " }: { navigatePath: string | null; className?: string }) {
  const { t } = useTranslation();
  const { normalInter } = useFontStyle();
  return (
    <div className={cn(className)}>
      <span className={cn(normalInter, `text-14 2xl:text-14 text-textHeadingColor ${navigatePath ? "cursor-pointer" : "cursor-default"}`)}>
        {t("common.read_more", { defaultValue: "Read More" })}
      </span>
    </div>
  );
}

export default ArticleReadMore;
